
import { restartableTask } from 'ember-concurrency';
import { IResourceName } from 'volta/models/base-model';
import TaskService from 'volta/services/task-service';
import { defaultErrorHandler } from 'volta/utils/error-utils';

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type SessionUserService from 'volta/services/session-user';
import type Task from 'volta/models/task';
interface IArgs {
  comment: Task;
  resourceName: IResourceName;
  disabled: boolean;
  onDelete?: (commentId: string) => void;
  onUpdate?: (comment: Task) => void;
}

export default class CommentItem extends Component<IArgs> {
  @service sessionUser!: SessionUserService;
  @service taskService!: TaskService;

  @tracked editMode = false;

  get isOwn() {
    return this.args.comment.createdBy?.id === this.sessionUser.user?.id;
  }

  deleteComment = restartableTask(async () => {
    try {
      await this.taskService.deleteTask.perform(this.args.comment);

      this.args.onDelete?.(this.args.comment.id);
    } catch (error) {
      defaultErrorHandler(error);
    }
  });

  editComment = restartableTask(async () => {
    if (this.args.comment.comment) {
      this.args.comment.set('comment', this.args.comment.comment.trim());
    }
    try {
      await this.taskService.saveTask.perform(this.args.comment);
      this.args.onUpdate?.(this.args.comment);
      this.editMode = false;
    } catch (error) {
      defaultErrorHandler(error);
    }
  });
}
